module.exports = __webpack_public_path__ + "static/img/clause_confirmation111.2c19fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_confirmation111.png
// module id = oPCk
// module chunks = 1